<template>
  <div class="article-box">
    <h5>法律保障</h5>
    <hr>

    <div class="article_content" v-html="data">
<!--
      <h4 style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:24px"><span style=";font-family:宋体;color:rgb(255,255,255);letter-spacing:0;font-weight:bold;font-style:normal;font-size:12px;background:rgb(27,184,226)">配资合法性</span></h4>
      <p style="margin-top:0;margin-right:0;margin-bottom:16px;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:19px"><span style=";font-family:宋体;color:rgb(128,128,128);letter-spacing:0;font-style:normal;font-size:16px;background:rgb(252,252,252)">配资属于民间借贷的一种形式，《合同法》和《最高人民法院关于人民法院审理借贷案件的若干意见》从法律上肯定了民间借贷行为的合法性，同时，可以采用第三方对借款提供担保的方式，保障出借人收回借款本金、利息的权利。&nbsp;因此，配资行为受法律保护。&nbsp;依据《最高人民法院关于人民法院审理借贷案件的若干意见》的规定，公民之间、公民与法人之间、公民与其他组织之间的借贷属于民间借贷。&nbsp;因此配资行为作为一种民事法律行为，在行为人具有完全民事行为能力（年满18周岁，且不存在足以影响自身行为的精神疾病的情形）、&nbsp;意思表示真实且不违反法律、行政法规禁止性规定的情况下，受到法律的保护。&nbsp;</span></p>
      <h4 style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:24px"><span style=";font-family:宋体;color:rgb(255,255,255);letter-spacing:0;font-weight:bold;font-style:normal;font-size:12px;background:rgb(170,188,100)">利率的规定</span></h4>
      <p style="margin-top:0;margin-right:0;margin-bottom:16px;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:19px"><span style=";font-family:宋体;color:rgb(128,128,128);letter-spacing:0;font-style:normal;font-size:16px;background:rgb(244,246,249)">（《合同法》第二百一十一条：自然人之间的借款合同对支付利息没有约定或者约定不明确的，视为不支付利息。自然人之间的借款合同约定支付利息的，借款的利率不得违反国家有关限制借款利率的规定。&nbsp;《最高人民法院关于人民法院审理借贷案件的若干意见》第六条：民间借贷的利率可以适当高于银行的利率，各地人民法院可根据本地区的实际情况具体掌握，但最高不得超过银行同类贷款利率的四倍（包含利率本数）。超出此限度的，超出部分的利息不予保护。</span></p>
      <h4 style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:24px"><span style=";font-family:宋体;color:rgb(255,255,255);letter-spacing:0;font-weight:bold;font-style:normal;font-size:12px;background:rgb(255,196,0)">关于借款协议的规定</span></h4>
      <p style="margin-top:0;margin-right:0;margin-bottom:16px;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:19px"><span style=";font-family:宋体;color:rgb(128,128,128);letter-spacing:0;font-style:normal;font-size:16px;background:rgb(252,252,252)">《最高人民法院关于人民法院审理借贷案件的若干意见》第十条：一方以欺诈、胁迫等手段或者乘人之危，使对方在违背真实意思的情况下所形成的借贷关系，应认定为无效。&nbsp;《最高人民法院关于人民法院审理借贷案件的若干意见》第十一条：出借人明知借款人是为了进行非法活动而借款的，其借贷关系不予保护。</span></p>
      <h4 style="margin-top:0;margin-right:0;margin-bottom:0;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:24px"><span style=";font-family:宋体;color:rgb(255,255,255);letter-spacing:0;font-weight:bold;font-style:normal;font-size:12px;background:rgb(251,90,0)">借款提供担保的规定</span></h4>
      <p style="margin-top:0;margin-right:0;margin-bottom:16px;margin-left:0;padding:0 0 0 0 ;text-align:left;vertical-align:middle;line-height:19px"><span style=";font-family:宋体;color:rgb(128,128,128);letter-spacing:0;font-style:normal;font-size:16px;background:rgb(252,252,252)">《合同法》第一百九十八条订立借款合同，贷款人可以要求借款人提供担保。担保依照《中华人民共和国担保法》的规定。&nbsp;《最高人民法院关于人民法院审理借贷案件的若干意见》第十三条：&nbsp;在借贷关系中，仅起联系、介绍作用的人，不承担保证责任。对债务的履行确有保证意思表示的，应认定为保证人，承担保证责任。</span></p>
      <p><span style=";font-family:'Times New Roman';font-size:14px">&nbsp;</span></p>
      <p><br></p>-->
    </div>
    <!---->


    <!--                    -->
  </div>
</template>

<script>
    export default {
      name: "helpstatement",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 18,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msg));
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  @import url("./../assets/css/style.css");
  *{
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 13px;
  }
  h5{
    font-size: 20px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpstatement.vue